// import { BreadcrumbMapping} from "./types/ui";

// breadcrumbMapping.js
// const breadcrumbMapping: BreadcrumbMapping = {
//     '/home': { base: 'Home', inner: ['Popular'] },
//     '/home/popular': { base: 'Home', inner: ['Popular'] },
//     '/home/artists': { base: 'Home', inner: ['Artists'] },
//     '/home/albums': { base: 'Home', inner: ['Albums'] },
//     '/home/genres': { base: 'Home', inner: ['Genres'] },
//     // TODO: ... add more mappings as needed
// };

// breadcrumbMapping.js
// import {BreadcrumbMapping} from "./types/ui";

// TODO: Take Breadcrumbs deeper for example /choirs/choir-name/members etc at the moment it only goes one level deep (i.e. /choirs/choir-name)
const breadcrumbMapping: (pathname: any) => { inner: string[]; base: string } = (pathname) => {
    const pathSegments = pathname.split('/').filter(Boolean);

    // Default breadcrumb
    let breadcrumb = {base: 'Home', inner: ['']};

    // Handle dynamic paths
    if (pathSegments.length) {
        if (pathSegments[0] === 'home') {
            breadcrumb.base = 'Home';

            if (pathSegments[1]) {
                switch (pathSegments[1]) {
                    // TODO: Work on default to be popular
                    // case '/':
                    //     breadcrumb.inner[0] = 'Popular';
                    //     break;
                    case 'popular':
                        breadcrumb.inner[0] = 'Popular';
                        break;
                    case 'artists':
                        breadcrumb.inner[0] = pathSegments[2] ? `Artist > ${pathSegments[2].replace(/%20/g, ' ').replace(/%E2%80%99/g, `'`)}` : 'Artists';
                        break;
                    case 'albums':
                        // Handle dynamic album ID
                        breadcrumb.inner[0] = pathSegments[2] ? `Album > ${pathSegments[2].replace(/%20/g, ' ').replace(/%E2%80%99/g, `'`)}` : 'Albums';
                        break;
                    case 'genres':
                        breadcrumb.inner[0] = 'Genres';
                        break;
                    // TODO: Add more cases as needed
                }
            }
        } else if (pathSegments[0] === 'community') {
            breadcrumb.base = 'Community';
            breadcrumb.inner[0] = pathSegments[1] ? pathSegments[1].replace(/%20/g, ' ').replace(/%E2%80%99/g, `'`) : 'Contributions';
        } else if (pathSegments[0] === 'marketplace') {
            breadcrumb.base = 'Marketplace';
            breadcrumb.inner[0] = '';
        } else if (pathSegments[0] === 'rehearsals') {
            breadcrumb.base = 'Rehearsals';
            breadcrumb.inner[0] = pathSegments[1] ? pathSegments[1].replace(/%20/g, ' ').replace(/%E2%80%99/g, `'`) : 'Rehearsals';
        } else if (pathSegments[0] === 'choirs') {
            breadcrumb.base = 'Choirs';
            if (pathSegments[1]) {
                breadcrumb.inner[0] = pathSegments[1] ? pathSegments[1].replace(/%20/g, ' ').replace(/%E2%80%99/g, `'`) : 'Choir';

            }
        } else if (pathSegments[0] === 'projects') {
            breadcrumb.base = 'Projects';
            breadcrumb.inner[0] = pathSegments[1] ? pathSegments[1].replace(/%20/g, ' ').replace(/%E2%80%99/g, `'`) : '';
        } else if (pathSegments[0] === 'contributions') {
            breadcrumb.base = 'Vocal Contributions';
            breadcrumb.inner[0] = pathSegments[1] ? pathSegments[1].replace(/%20/g, ' ').replace(/%E2%80%99/g, `'`) : 'Contributions';
        } else if (pathSegments[0] === 'uploads') {
            breadcrumb.base = 'Uploads';
            breadcrumb.inner[0] = pathSegments[1] ? pathSegments[1].replace(/%20/g, ' ').replace(/%E2%80%99/g, `'`) : 'Uploads';
        } else if (pathSegments[0] === 'request songs') {
            breadcrumb.base = 'Request Songs';
            breadcrumb.inner[0] = pathSegments[1] ? pathSegments[1].replace(/%20/g, ' ').replace(/%E2%80%99/g, `'`) : '';
        } else if (pathSegments[0] === 'account information') {
            breadcrumb.base = 'Account Information';
            if (pathSegments[1] === 'purchases') {
                breadcrumb.inner[0] = 'My Purchases';
            } else if (pathSegments[1] === 'orders') {
                breadcrumb.inner[0] = 'My Orders';
            } else if (pathSegments[1] === 'listings') {
                breadcrumb.inner[0] = 'My Listings';
            } else if (pathSegments[1] === 'earnings') {
                breadcrumb.inner[0] = 'Earnings';
            } else if (pathSegments[1] === 'edit profile') {
                breadcrumb.inner[0] = 'Edit Profile';
            } else if (pathSegments[1] === 'update card') {
                breadcrumb.inner[0] = 'Update Card';
            } else if (pathSegments[1] === 'available plans') {
                breadcrumb.inner[0] = 'Available Plans';
            } else if (pathSegments[1] === 'manage plans') {
                breadcrumb.inner[0] = 'Manage Plans';
            } else if (pathSegments[1] === 'order history') {
                breadcrumb.inner[0] = 'Order History';
            } else {
                breadcrumb.inner[0] = pathSegments[1] ? pathSegments[1].replace(/%20/g, ' ').replace(/%E2%80%99/g, `'`) : '';
            }
        } else if (pathSegments[0] === 'request role') {
            breadcrumb.base = 'Request Role';
            breadcrumb.inner[0] = pathSegments[1] ? pathSegments[1].replace(/%20/g, ' ').replace(/%E2%80%99/g, `'`) : '';
        } else if (pathSegments[0] === 'notifications') {
            breadcrumb.base = 'Notifications';
        } else if (pathSegments[0] === 'transaction history') {
            breadcrumb.base = 'Transaction History';
        } else if (pathSegments[0] === 'search') {
            breadcrumb.base = 'Search';
            breadcrumb.inner[0] = pathSegments[1] ? `Results for "${pathSegments[1].replace(/%20/g, ' ').replace(/%E2%80%99/g, `'`)}"` : '';
        }
    }

    return breadcrumb;
};


export default breadcrumbMapping;
